import { connect } from 'react-redux';

import { bindActionCreators } from 'redux';

import Header from '../../../../components/Templates/A/Header';
import { Creators as Actions } from '../../../../redux/reducers/app';

const mapStateToProps = ({ app: { header, asPath, plataform } }) => ({
  header,
  asPath,
  plataform,
});

const mapDispatchToProps = (dispatch) => bindActionCreators(Actions, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Header);
